export default {"src":"/_next/static/media/icon-one.2f723513.svg","height":22,"width":22};